import React, { useState,useEffect} from 'react';
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Modal} from 'react-bootstrap';
import Image from "../../components/image";
import { asset } from "../../helpers/dom.helper";
import { ContentWrapper } from "../../layouts";
import { Media, MediaContextProvider } from "../../media";
import Guarantee from "../../pages/Home/guaranteeHome";
import RegisterHome from "../../pages/Home/registerHome";
import Blog from "../../components/blogFooter/blogFooter";
import styles from './seminar.module.scss';
import './style.scss';

export default function Seminar2Page() {

     const { t } = useTranslation(['translation', 'privilege'])
     const [isExpanded, setIsExpanded] = useState(false);
     const [show, setShow] = useState(false);
     const [email, setEmail] = useState('');

     const handleClose = () => setShow(false);
     const handleShow = () => setShow(true);

     const [topPercentage, setTopPercentage] = useState(45);
     const [behavior, setBehavior] = useState('');

    useEffect(() => {
        const handleScroll = () => {
        const scrollY = window.scrollY; // Current scroll position
        let regisSeminarDefault 
        let behavior 
        if(scrollY <= 0){
            regisSeminarDefault = 45
           behavior = 'top 0.3s smooth'
        }else{
            regisSeminarDefault = 20
           behavior = 'opacity 0.4s, color ease-in-out 0.2s, background ease-in-out 0.2s'
        }
        setTopPercentage(regisSeminarDefault); // Update state
        setBehavior(behavior)
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
}, []);
   
     // Function to handle the sending of email using mailto:
     const handleSendEmail = (event) => {
       event.preventDefault();
       const subject = "สัมนา สิทธิและหน้าที่ของนิติบุคคลหมู่บ้านจัดสรรและอาคารชุด"; // You can modify the subject
       const body = "https://silverman.app/seminar"; // You can modify the body content
       
       window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
       handleClose(); // Close the modal after sending the email
     };
   

     const toggleShowMore = () => {
        setIsExpanded(!isExpanded);
     };

     const regisSeminar =()=>{
        return (
            /*<div className="regis-seminar2-wrapper">*/
            <div style={{
                    position: 'fixed',
                    top: `${topPercentage}vh`,
                    // right: '8%',
                    // width: '20%',
                    // marginTop: `${topPercentage}%`, // Dynamically set top based on scroll
                    // maxWidth: '390px',
                    borderRadius: '20px',
                    padding: '20px',
                    boxShadow: '0px 2px 20px 0px #2D2D3026',
                    backgroundColor: '#fff',
                    zIndex: 1000,
                    cursor: 'pointer',
                    transition: `${behavior}`,
                   // transition: 'bottom 0.3s smooth', 
                }}>
                <div className="text-center">
                <p style={{fontSize:'24px',margin:'0'}}><strong>2 วัน <span className="text-primary pl-2 pr-2" style={{fontSize:'32px',fontWeight:'400'}}>4,900</span> บาท</strong></p>
                <p className="text-gray" style={{fontSize:'16px'}}>(หากต้องการร่วมสัมนา 1 วัน 2,900 บาท)</p>
                <div>
                    <a href="https://forms.gle/P5j3gcFAMpHfeN5C6" target="_blank" rel="noopener noreferrer"> 
                        <button className="btn btn-register-home" style={{width:'90%',height:'45px'}}>
                            <span dangerouslySetInnerHTML={{ __html: t("privilege:ลงทะเบียน") }} />
                        </button>
                    </a>
                    <p className="text-center text-gray pt-2" style={{fontWeight:'400px'}}>แชร์</p>
                    <div className="row justify-content-center">
                    <div className="col-2">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=https://silverman.app/seminar" target="_blank" rel="noopener noreferrer">
                            <img src={asset('/images/seminar/fb.png')} className="pr-1" alt="fb" />
                        </a>
                    </div>
                    <div className="col-2">
                        <span onClick={handleShow} style={{cursor:'pointer'}}>
                            <img src={asset('/images/seminar/mail.png')} className="pr-1" alt="mail" />
                        </span>
                    </div>
                    </div>
                </div>
                </div>
                <p className="pt-2" style={{marginBottom:0}}>จัดโดย </p>
                <p><strong>ทนายบ้านและคอนโด</strong> ร่วมกับ <strong>Silverman Application</strong></p>
                <div>
                    <p style={{marginBottom:0}}>หมายเหตุ</p>
                    <ul style={{marginBottom:0}}>
                        <li>เงื่อนไขเป็นตามที่บริษัทฯ กำหนด</li>
                        <li>เมื่อชำระเงินแล้วไม่สามารถขอคืนได้</li>
                        <li>อาจมีการบันทึกภาพและเสียงในงานสัมมนา </li>
                    </ul>
                </div>
                <div>
                    <p className="pt-2" style={{marginBottom:0}}><strong>ช่องทางการชำระเงิน</strong></p>
                    <div className="row">
                        <div className="col-4">บัญชี </div>
                        <div className="col-8"><img src={asset('/images/seminar/kbank.png')} className="pr-1" alt="kbank" />ธนาคารกสิกรไทย</div>
                    </div>
                    <div className="row">
                        <div className="col-4">ชื่อบัญชี </div>
                        <div className="col-8">บริษัท พอร์ต 80 จำกัด</div>
                    </div>
                    <div className="row">
                        <div className="col-4">เลขที่บัญชี</div>
                        <div className="col-8">071-1-62697-2</div>
                    </div>
                </div>
            </div>
        )
     }

     const regisSeminarMobile =()=>{
        return (
            <div className="regis-seminar2-wrapper">
            <div className='regis-seminar2'>
                <div className="text-center">
                <p style={{fontSize:'24px',margin:'0'}}><strong>2 วัน <span className="text-primary pl-2 pr-2" style={{fontSize:'32px',fontWeight:'400'}}>4,900</span> บาท</strong></p>
                <p className="text-gray" style={{fontSize:'16px'}}>(หากต้องการร่วมสัมนา 1 วัน 2,900 บาท)</p>
                <div>
                    <a href="https://forms.gle/P5j3gcFAMpHfeN5C6" target="_blank" rel="noopener noreferrer"> 
                        <button className="btn btn-register-home" style={{width:'90%',height:'45px'}}>
                            <span dangerouslySetInnerHTML={{ __html: t("privilege:ลงทะเบียน") }} />
                        </button>
                    </a>
                    <p className="text-center text-gray pt-2" style={{fontWeight:'400px'}}>แชร์</p>
                    <div className="row justify-content-center">
                    <div className="col-2">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=https://silverman.app/seminar" target="_blank" rel="noopener noreferrer">
                            <img src={asset('/images/seminar/fb.png')} className="pr-1" alt="fb" />
                        </a>
                    </div>
                    <div className="col-2">
                        <span onClick={handleShow} style={{cursor:'pointer'}}>
                            <img src={asset('/images/seminar/mail.png')} className="pr-1" alt="mail" />
                        </span>
                    </div>
                    </div>
                </div>
                </div>
                <p className="pt-2" style={{marginBottom:0}}>จัดโดย </p>
                <p><strong>ทนายบ้านและคอนโด</strong> ร่วมกับ <strong>Silverman Application</strong></p>
                <div>
                    <p style={{marginBottom:0}}>หมายเหตุ</p>
                    <ul style={{marginBottom:0}}>
                        <li>เงื่อนไขเป็นตามที่บริษัทฯ กำหนด</li>
                        <li>เมื่อชำระเงินแล้วไม่สามารถขอคืนได้</li>
                        <li>อาจมีการบันทึกภาพและเสียงในงานสัมมนา </li>
                    </ul>
                </div>
                <div>
                    <p className="pt-2" style={{marginBottom:0}}><strong>ช่องทางการชำระเงิน</strong></p>
                    <div className="row">
                        <div className="col-4">บัญชี </div>
                        <div className="col-8"><img src={asset('/images/seminar/kbank.png')} className="pr-1" alt="kbank" />ธนาคารกสิกรไทย</div>
                    </div>
                    <div className="row">
                        <div className="col-4">ชื่อบัญชี </div>
                        <div className="col-8">บริษัท พอร์ต 80 จำกัด</div>
                    </div>
                    <div className="row">
                        <div className="col-4">เลขที่บัญชี</div>
                        <div className="col-8">071-1-62697-2</div>
                    </div>
                </div>
            </div>
            </div>
        )
     }
    return (
      <>
        <Helmet>
          <title>สัมนา สิทธิและหน้าที่ของนิติบุคคลหมู่บ้านจัดสรรและอาคารชุด | Silverman Application</title>
          <meta name="description" content={t("debt:สัมนา สิทธิและหน้าที่ของนิติบุคคลหมู่บ้านจัดสรรและอาคารชุด")} />
          <meta name="keywords" content={t("debt:metaKeyWord")} />
          <link rel="canonical" href="https://silverman.app/seminar" />  
        </Helmet>
        <div className={styles.seminarWrapper2+ " "+"seminar-wrapper2"}>
            <ContentWrapper className="pt-sm-5 ">
                <Modal show={show} onHide={handleClose}>
                    <Modal.Body>
                        <form onSubmit={handleSendEmail}>
                            <div className='row'>
                                <div className="col-md-12">
                                    <div className="field">
                                        <input 
                                            required
                                            name="email" id="email"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        <label htmlFor="name" style={{fontSize:'16px'}}>{t("home:ระบุอีเมล")}<span className='text-danger'>*</span></label>
                                    </div>
                                </div>
                            </div>
                            <div className='row pt-4'>
                                <div className='col-md-12' style={{textAlign:'end'}}>
                                    <button className='btn btn-outline-primary mr-2' onClick={handleClose}>
                                        ยกเลิก
                                    </button>
                                    <button className='btn btn-primary' type='submit'>
                                        ตกลง
                                    </button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                <MediaContextProvider>
                    <h2 className="text-center">สัมนา สิทธิและหน้าที่ของนิติบุคคลหมู่บ้านจัดสรรและอาคารชุด</h2>
                    <h1 className="text-primary text-center pt-2">ภาค จับผิด ตรวจทุจริต ปราบโกง !!</h1>
                    <div className="dateSeminar-wrapper">
                        <div style={{width:'400px'}}>
                            <div className="row justify-content-center">
                                <div className="col-1 text-primary text-number-title pl-2">2</div>
                                <div className="col-1 text-to-title"><span>ถึง</span></div>
                                <div className="col-1 text-primary text-number-title pr-2">3</div>
                                <div className="col-5 text-date-title"><span>พฤศจิกายน 2567 <br/> 9:00 -17:30 น.</span></div>
                            </div>
                        </div>
                    
                    </div>
                    <p className="text-center text-secondary pt-2" style={{textDecoration:'underline',fontSize:'18px'}}>
                    <a href='https://maps.app.goo.gl/bHKZzP6JoHdEsApu6?g_st=il' target='_blank'>ณ Victor Club ตึก FYI CENTER</a> 
                    </p>
                    <div className="pb-4">
                        <div className='row'>
                            <div className='col-md-8'>
                                <Image  
                                    src={asset('/images/seminar/seminar2.webp')}
                                    alt="seminar" className='img-fluid'/>
                            </div>
                            <div className='col-md-4'> 
                                <div className='only-desktop-regis-simenar2'>
                                    {regisSeminar()}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="only-mobile-regis-simenar2">
                        {regisSeminarMobile()}
                    </div>
                    <div className="row pb-5">
                        <div className="col-lg-8">
                            <div className="">
                                <h4>เชิญร่วมสัมมนาความรู้เพื่อการจัดการนิติบุคคลอาคารชุดและหมู่บ้านจัดสรร ประจำปี 2567</h4>
                                <h5 className="text-primary pt-2">งานนี้จัดขึ้นเพื่อ “กรรมการนิติบุคคล ลูกบ้าน และเจ้าของร่วม หมู่บ้านจัดสรรและอาคารชุด” เท่านั้น !!</h5>
                                <h5 className="pt-3" style={{marginBottom:'0'}}><strong>ทำไมถึงต้องรู้ทัน “การจับผิด ตรวจสอบทุจริต ปราบโกง” การทำงานของกรรมการนิติบุคคล และนิติบุคคล ?</strong></h5>
                                <span>ปัญหาหลักที่สร้างความปวดหัวและความทุกข์ทรมานใจในการอยู่อาศัยในหมู่บ้านจัดสรรและอาคารชุด คือการที่มีลูกบ้าน <br/>
                                และเจ้าของร่วมต้องประสบพบเจอความไม่ยุติธรรม ทั้งการใช้เงินส่วนกลาง และข้อบังคับของนิติบุคคลที่เอื้อต่อ
                                </span>
                                {/* {isExpanded && (  */}
                                <div>
                                    <span>
                                    แค่บุคคลใดบุคคลหนึ่ง ซึ่งความไม่ยุติธรรมนี้เป็นการใช้เงินกองกลาง และยังเป็นการละเมิดสิทธิของลูกบ้านและ
                                    เจ้าของร่วมทุกคนให้ปฏิบัติตาม <br/>กฎเกณฑ์อีกด้วย ซึ่งทำให้บ้านและสังคมที่ต้องอยู่ร่วมกันนั้นไม่มีความน่าอยู่ เสื่อมโทรม 
                                    และสร้างความอึดอัดในการอยู่อาศัย </span>

                                    <h5 className="pt-4 pb-2">เนื้อหาที่ความรู้ที่จะได้ในงานสัมมนาครั้งนี้ อัดแน่นและบรรยายโดยผู้ทรงคุณวุฒิเฉพาะด้านและมากประสบการณ์</h5>
                                <ul>
                                    <li>ภาพรวมการวิเคราะห์ตลาดอสังหาริมทรัพย์ไทย และแนวโน้มในอนาคต <br/>
                                    <strong>โดย อ.ดร. โสภณ พรโชคชัย ผู้อำนวยการโรงเรียนธุรกิจอสังหาริมทรัพย์ไทย และนายกสมาคมผู้ซื้อบ้าน</strong></li>
                                    <li className="pt-4">บทบาทและหน้าที่ในการบริหารงานนิติบุคคลอาคารชุดของกรรมการนิติบุคคล ผู้จัดการนิติบุคคล และการประชุม
                                        วิสามัญและการตรวจสอบเอกสารที่เกี่ยวข้องกับการเบิกจ่ายและเรียกเก็บค่าส่วนกลาง และรายได้อื่นของนิติบุคคล
                                        อาคารชุด <br/><strong>โดย อ.นันทิยา ทองยิ่งสกุล อดีตผู้อำนวยการส่วนอาคารชุด สำนักงานส่งเสริมธุรกิจอสังหาริมทรัพย์ 
                                    กรมที่ดิน กระทรวงมหาดไทย</strong>
                                    </li>
                                    <li className="pt-4">การบันทึกบัญชี รายรับ รายจ่าย สำหรับนิติบุคคลหมู่บ้านจัดสรร และอาคารชุดที่ถูกต้อง  <br/>
                                    <strong>โดย อ. สุรภา แจ่มแจ้ง นักบัญชีและภาษี ผู้ตรวจสอบบัญชี CPA เจ้าของเพจ คุณเก่งบัญชี ภาษีบรรเทา</strong>
                                    <br/><a href='https://www.youtube.com/@KengBuncheePasiBuntao' target='_blank'>(https://www.youtube.com/@KengBuncheePasiBuntao)</a></li>
                                    <li className="pt-4">การตรวจสอบแก้ไขปัญหา และการระงับข้อพิพาท เรื่องการบริหารจัดการงานนิติบุคคลหมู่บ้านจัดสรร อาคารชุด
                                        <br/><strong>โดย อ. วิวัธน์ ศรีเจริญวงศ์ อดีตนายกสมาคมบริหารสินทรัพย์</strong>
                                    </li>
                                    <li className="pt-4">มาตรการในการระงับข้อพิพาทตามกฎหมาย เมื่อเกิดเหตุต้องสงสัยในการทุจริต หรือ การบริหารงานที่ไม่โปร่งใส 
                                        ของนิติบุคคลหมู่บ้านจัดสรรและอาคารชุด 
                                        <br/><strong>โดย ทีมวิทยากร ทนายบ้านและคอนโด</strong>
                                    </li>
                                    <li className="pt-4">การใช้เทคโนโลยีในการช่วยบริหารจัดการเพื่อการทำงานนิติบุคคลที่โปร่งใส่ สามารถตรวจสอบได้​ด้วย 
                                    Silverman Application <br/>
                                    <strong>โดย คุณณิชชา ภาณุนันทน์ Silverman Specialist </strong>
                                    <br/><a href='https://silverman.app/' target='_blank'>(https://silverman.app/)</a></li>
                                    <li className="pt-4">การแบ่งปันการทำงานและการแก้ปัญหาของการบริหารนิติบุคคล
                                        <br/><strong>โดย คุณดรณ์ ญาณนารา ผู้จัดการนิติบุคคล และผู้บริหารนิติบุคคลอาคารชุดมามากกว่า 10 ปี (5 สมัย) และ
                                    คุณวีรวิชญ์ ทิพยชัยวรุตม์ ประธานหมู่บ้าน ไอลีฟทาวน์ 2 ประชาอุทิศ 90 มีประสบการณ์จัดตั้งนิติ และอยู่ใน
                                    คณะกรรมการบริหารนิติมากกว่า 6 ปี</strong>
                                    </li>
                                </ul>
                                <h4 className="text-primary pt-2">จัดขึ้น 2 วันเท่านั้น !!</h4>
                                <div className="video-container">
                                    <video className="responsive-video" controls>
                                        <source src="https://silverman-storage.sgp1.cdn.digitaloceanspaces.com/website-static/vdo/E9C884E3A9BBC34DD34654381EA989CF0710FA1A.mp4" type="video/mp4" />
                                    </video>
                                </div>
                                <div className='pt-4 pb-2'>
                                    <div className="video-container">
                                        <video className="responsive-video" controls>
                                            <source src="https://silverman-storage.sgp1.cdn.digitaloceanspaces.com/website-static/vdo/1E3A572CBCB01FE0556F02E9809E9EB61458358B.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                                </div>
                                <p className="pt-2 pb-2"><strong>วันเสาร์และอาทิตย์ที่ 2-3 พฤศจิกายน 67</strong></p>
                                <p style={{marginBottom:0}}>Early Bird !! สำรองที่นั่งภายใน 20 ตุลาคม นี้</p>
                                <p style={{marginBottom:0}}><strong className="text-primary">ราคาเพียง 4,900 บาท เท่านั้น สำหรับ 2 วัน !!</strong>(จากราคาเต็ม 7,800 บาท)</p>
                                <p className="pt-3"><strong>วันที่ 1 : ภาคจับผิด ตรวจทุจริต ปราบโกง เพื่อความโปร่งใสในการบริหารงานนิติบุคคลอาคารชุด</strong><br/>
                                วันเสาร์ที่ 2 พฤศจิกายน 2567 เวลา 09:00 – 17:30น <br/>จำนวนผู้เข้าอบรม 120 - 150 ท่าน เท่านั้น
                                </p>
                                <p className="pt-2"><strong>วันที่ 2 : ภาคจับผิด ตรวจทุจริต ปราบโกง เพื่อความโปร่งใสในการบริหารงานนิติบุคคลหมู่บ้านจัดสรร</strong><br/>
                                วันอาทิตย์ที่ 3 พฤศจิกายน 2567 เวลา 09:00 – 17:30น <br/>จำนวนผู้เข้าอบรม 120 - 150 ท่าน เท่านั้น
                                </p>
                                <p className="text-primary pt-2"><strong>*สำหรับผู้ที่ประสงค์ที่จะรวมสัมมนาเพียงวันเดียว สามารถเลือกเข้าร่วมอบรมวันใดก็ได้
                                ใน ราคาเพียง 2,900 บาท เท่านั้น ! (จากราคาเต็ม 3,900 บาท) </strong></p>

                                <p><strong>พิเศษ !! สำหรับผู้ร่วมสัมมนาทุกท่านจะได้รับใบประกาศนียบัตรการเข้าร่วมสัมมนาในครั้งนี้ และยังได้</strong></p>
                                <ul>
                                    <li className="pt-2 pb-2">ฟรี - นัดหมายปรึกษาปัญหาด้านนิติบุคคล กับทางทนายบ้านและคอนโด</li>
                                    <li className="pt-2 pb-2">ฟรี - คำปรึกษาการนำเทคโนโลยีมาใช้ในการบริหารจัดการนิติบุคคล โดย Silverman Application</li>
                                    <li className="pt-2 pb-2">ฟรี - ให้คำปรึกษาและคำแนะนำในการสร้างรายได้ใหม่ๆให้กับทางนิติบุคคล โดย Silverman Application</li>
                                    <li className="pt-2 pb-2">ฟรี - ค่าใช้จ่ายในการขึ้นระบบ Silverman PMS ครั้งแรก มูลค่า 5,000 บาท (เฉพาะท่านที่สนใจเปิดใช้งานระบบ 
                                        Silverman PMS ในวันงานเท่านั้น)</li>
                                    <li className="pt-2 pb-2">ฟรี - วิธีการออก E-Notice ทวงถามค่าส่วนกลางผ่านระบบ Silverman Application โดย AI (เฉพาะท่านที่สนใจ
                                        เปิดใช้งานระบบ Silverman PMS ในวันงานเท่านั้น)</li>
                                    <li className="pt-2 pb-2">ฟรี - อาหาร ขนม และเครื่องดื่ม ตลอดงาน</li>
                                </ul>
                                <p><strong>จัดที่ Victor Club ตึก FYI Center ติด ​MRT ศูนย์ประชุมแห่งชาติสิริกิติ์ ทางออก 1</strong></p>
                                <p><u><a href="https://maps.app.goo.gl/bHKZzP6JoHdEsApu6?g_st=il" target='_blank'>https://maps.app.goo.gl/bHKZzP6JoHdEsApu6?g_st=il</a></u></p>
                                <p>เวลาสัมมนา 9.00- 17.30 น.</p>
                                <p><strong>จัดโดย ทนายบ้านและคอนโด ร่วมกับ Silverman Application</strong></p>
                                <p style={{marginBottom:0}}>หมายเหตุ</p>
                                <ul>
                                    <li>เงื่อนไขเป็นตามที่บริษัทฯ กำหนด</li>
                                    <li>เมื่อชำระเงินแล้วไม่สามารถขอคืนได้</li>
                                    <li>อาจมีการบันทึกภาพและเสียงในงานสัมมนา </li>
                                </ul>
                                <p className="pt-2 pb-1" style={{marginBottom:0}}><strong>ช่องทางการชำระเงิน</strong></p>
                                <ul className="no-bullets">
                                    <li>1) โอนเงินเข้าบัญชี: </li>
                                    <li>บัญชี ธนาคารกสิกรไทย ชื่อบัญชี บริษัท พอร์ต 80 จำกัด</li>
                                    <li>เลขที่บัญชี 071-1-62697-2</li>
                                </ul>
                                <p>2) ชำระโดนบัตรเครดิต สามารถคลิก link ด้านล่างได้เลย <br/>
                                 <a href='https://buy.stripe.com/14k7va7vgfH45Ik5kk' target='_blank'>https://buy.stripe.com/14k7va7vgfH45Ik5kk</a></p>

                                <p className="pt-2" style={{marginBottom:0}}><strong>ติดต่อสอบถามข้อมูลเพิ่มเติม</strong></p>
                                <div>
                                    <div className="row">
                                        <div className="col-md-2 col-sm-1">Facebook: </div>
                                        <div className="col-md-1 col-sm-4"><u><a href="https://www.facebook.com/SilvermanApp" target='_blank'>https://www.facebook.com/SilvermanApp</a> </u></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2 col-sm-1">โทร: </div>
                                        <div className="col-md-4 col-sm-4">081-442-6888</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2 col-sm-1">Line ID: </div>
                                        <div className="col-md-4 col-sm-4">@silvermanapp</div>
                                    </div>
                                </div>
                                </div>
                                {/* ) } */}
                                {/* <p onClick={toggleShowMore} className='toggleShowMore read-more'>
                                <span className={isExpanded ? '' : 'trigger'}> {isExpanded ? 'แสดงน้อยลง' : 'แสดงเพิ่มเติม'} <img src={asset(`/images/seminar/${isExpanded ? 'arrow-up.png':'arrow-down.png'}`)} style={{width:'15px'}}className="pr-1" alt="arrow-down" /></span> 
                                </p> */}
                            </div>
                        </div>
                    </div>
              </MediaContextProvider>  
            </ContentWrapper>
            <div className="row">
                <div className="col-3"></div>
                <div className="col-6 text-center">
                    <div className="register">
                    <MediaContextProvider>
                        <Media greaterThanOrEqual="md">
                            <RegisterHome />
                        </Media>
                    </MediaContextProvider>
                    </div>
                </div>
                <div className="col-3"></div>
            </div>
            <Guarantee />
            <Blog />
        </div>
      </>
    )
  
  }